/** **************************************************************************************************
 * Action Confirmation
 *************************************************************************************************** */
const prefix = `CONFIRM_ACTION_`;
export const CONFIRM_ACTION_SET_NEXT_ACTION = `${prefix}NEXT_ACTION`;
export const CONFIRM_ACTION_ASK_CONFIRM_ACTION = `${prefix}ASK_CONFIRM_ACTION`;
export const CONFIRM_ACTION_CONFIRM_ACTION = `${prefix}CONFIRM_ACTION`;
export const CONFIRM_ACTION_CANCEL_ACTION = `${prefix}CANCEL_ACTION`;

export const CONFIRM_ACTION_SHOW_CONFIRM_ACTION_MODAL = `${prefix}SHOW_CONFIRM_ACTION_MODAL`;
export const CONFIRM_ACTION_HIDE_CONFIRM_ACTION_MODAL = `${prefix}HIDE_CONFIRM_ACTION_MODAL`;
